var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.name))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(item.price)))]),_c('td',[_vm._v(_vm._s(item.total_quantity))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Ticket Name")]),_c('th',[_vm._v("Price")]),_c('th',[_vm._v("Quantity")])])])
}]

export { render, staticRenderFns }